import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import ListPageDX from "../../components/business/listpagedx";
import { useNotificationContext } from "../../context/notificationcontext";
import useSubscriptionPackageService from "../../shared/services/subscriptionpackageservice";
import PackageForm from "../../components/units_forms/packageform";

const Packages = () => {
  const { t, i18n } = useTranslation();
  const { setAddRecordfn, setAddRecordLabel } = useOutletContext() as any;
  const { setInfo, setError } = useNotificationContext();
  const { getSubscriptionPackages, archiveSubscriptionPackage } =
    useSubscriptionPackageService();

  const [rows, setRows] = useState<any>([]);
  const [dataFromApi, setDataFromApi] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: `${t("Name")}`,
      minWidth: 150,
    },
    {
      field: "description",
      headerName: `${t("Description")}`,
      flex: 1,
    },
    {
      field: "price",
      headerName: `${t("Price")}`,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "packageDays",
      headerName: `${t("Package Days")}`,
      headerAlign: "center",
      align: "center",
      width: 130,
    },
    {
      field: "bufferDays",
      headerName: `${t("Buffer Days")}`,
      headerAlign: "center",
      align: "center",
      width: 130,
    },
  ];

  const getData = () => {
    setIsLoading(true);
    getSubscriptionPackages()
      .then((data) => {
        setDataFromApi(data);
        setRows(data);
      })
      .catch((err) => setError(err))
      .finally(() => setIsLoading(false));
  };

  const toCreate = () => {
    navigate("/packagedetails", {
      state: {
        packageData: null,
      },
    });
  };
  const onEdit = (data: any) => {
    navigate(`/packagedetails`, {
      state: {
        packageData: data,
      },
    });
  };

  const onDelete = (id: number) => {
    setIsLoading(true);
    archiveSubscriptionPackage(id)
      .then(() => {
        setInfo(t("Package deleted successfully"));
        getData();
      })
      .catch((err) => setError(err))
      .finally(() => setIsLoading(false));
  };

  const setGridFilterCriteria = (value: string) => {
    if (!value.trim()) {
      setRows(dataFromApi);
      return;
    }
    const newRows = dataFromApi.filter(
      (row: any) =>
        row.name.toLowerCase().includes(value.toLowerCase()) ||
        row.description.toLowerCase().includes(value.toLowerCase()),
    );
    setRows(newRows);
  };

  useEffect(() => {
    getData();
    setAddRecordfn(() => toCreate);
    setAddRecordLabel(t("Add Package"));

    return () => {
      setAddRecordfn(() => {});
      setAddRecordLabel(t("Add Record"));
    };
  }, [i18n.language]);

  return (
    <ListPageDX
      listTitle={t("Packages")}
      name={t("Packages")}
      rows={rows}
      columns={columns}
      getRowId={(row: any) => row.subscriptionPackageId}
      isLoading={isLoading}
      onEdit={onEdit}
      onDelete={onDelete}
      editLabel={t("Preview")}
      setGridFilterCriteria={setGridFilterCriteria}
      exportToPDF={false}
      exportToCSV={false}
      showDatePicker={false}
      showSelect={false}
    />
  );
};

export default Packages;
